enum FlashType {
    OK, BAD, PENDING, WARNING, NOTICE
}

export default FlashType;
